import { SEARCH_INPUT_VALUE } from "./actionType";

export const searchValue = (value) => {
  return {
    type: SEARCH_INPUT_VALUE,
    payload: value,
  };
};
